import React from 'react'
import { Typography, Input } from 'antd'
import { appVersion, versionWeb } from '../../../utils/auth'

const { Text, Title } = Typography
const { Search } = Input;

class FooterLogin extends React.PureComponent {

	render() {
		const { title, subtitle } = this.props
		return (
			<>
                <div style={{ textAlign: 'center',fontSize:"12px", flexShrink:"0" }} >
                    สงวนลิขสิทธิ์ โดย สภากาชาดไทย<br></br> 1871 ถนนพระราม4 แขวงปทุมวัน เขตปทุมวัน กรุงเทพฯ 10330<br></br>
                    {/* Powered by : Kasikornbank Public Co., Ltd. */}
                    <br></br>
                    <Text className="text-web-app" style={{ backgroundColor:"rgb(255 255 255 / 55%);" }}>
                        { versionWeb() } {appVersion()}
                    </Text>
                </div>
			</>
		)
	}
}

export default FooterLogin